export default "__VITE_ASSET__Chiz50dc__"